export default "__VITE_ASSET__kDKoab9W__"